<template>
    <!-- 新嗨优才大屏 -->
    <div class="newHiYouCaiDiv">
        <div class="hiYouCaiTitleClass">
            <template>
                <div class="leftModellingClass">
                    <div class="jiweiClass">{{dateStr}}</div>
					<div class="jiweiClass_mobile">{{dateStr_mobile}}</div>
                </div>
            </template>
            <template>
                <div class="topRightModellingClass">
                    <div v-if="jiWeiBool" @mouseover="mouseEnter" class="jiweiClass">切换到几维空间会员</div>
                    <div v-else @mouseout="mouseLeave" class="goJiWeiClass" @click="gojiweiClick">切换到几维空间会员</div>
                </div>
				<div class="topRightModellingClass_mobile">
				    <div v-if="jiWeiBool" @mouseover="mouseEnter" class="jiweiClass">切换到几维空间会员</div>
				    <div v-else @mouseout="mouseLeave" class="goJiWeiClass" @click="gojiweiClick">切换到几维空间会员</div>
				</div>
            </template>
        </div>
        <!-- 里面的内容 -->
        <div class="contentDiv">
            <!-- 左边 -->
            <div class="leftDiv">
                <div class="leftTopDiv">
                    <template v-if="roleType == 1">
                        <leftBackView 
                            class="modellingClass"
                            width="80%"
                            height="60px"
                            describeText="用户来源渠道分布">
                        </leftBackView>
                        <roundChart 
                            style="width: 100%; height: 80%" 
                            :dataArr="userData"
                            :totalText="userSum">
                        </roundChart>
                    </template>
                    <template v-if="roleType == 2">
                        <leftBackView 
                            class="modellingClass"
                            width="80%"
                            height="60px"
                            describeText="部门客户数量">
                        </leftBackView>
                        <roundChart 
                            style="width: 100%; height: 80%"
                            :dataArr="userData"
                            :totalText="userSum">
                        </roundChart>
                    </template>
                </div>
                <div class="leftBottomDiv">
                    <leftBackView 
                        class="modellingClass"
                        width="80%"
                        height="60px"
                        describeText="用户跟踪情况">
                    </leftBackView>
                    <template v-if="!solidXArr">
                        <div class="noDataClass">
                            暂无数据
                        </div>
                    </template>
                    <template v-else>
                        <solidBarChart 
                            style="width: 100%; height: 80%"
                            width='100%'
                            height='100%'
                            refName="newSolidBar"
                            :chartXArr="solidXArr"
                            :chartYArr="solidYArr">
                        </solidBarChart>
                    </template>
                </div>
            </div>
            <!-- 中间 -->
            <div class="middleDiv">
                <!-- 顶部统计数据 -->
                <div :class="roleType == 1 ? 'topStatisClass' : 'topStatisClass chiefClass'">
                    <template v-if="roleType == 1">
                        <staticView 
                            width="160px"
                            height="160px"
                            :totalText="order_num"
                            :companyName="orderCompany"
                            describeText="订单总数">
                        </staticView>
                        <staticView 
                            width="160px"
                            height="160px"
                            :totalText="user_total"
                            companyName="人"
                            describeText="用户总数">
                        </staticView>
                        <staticView 
                            width="160px"
                            height="160px"
                            :totalText="sale_amount"
                            companyName="万"
                            describeText="销售总额">
                        </staticView>
                    </template>
                    <template v-if="roleType == 2">
                        <staticView 
                            width="160px"
                            height="160px"
                            :totalText="order_num"
                            :companyName="orderCompany"
                            describeText="订单总数">
                        </staticView>
                        <staticView 
                            width="160px"
                            height="160px"
                            :totalText="user_total"
                            companyName="人"
                            describeText="用户总数">
                        </staticView>
                    </template>
                </div>
                <!-- 地图 -->
                <div class="newMapClass">
                    <template v-if="roleType == 1">
                        <hi-map 
                            class="hiMapViewClass"
                            :mapTackData="allNational"
                            :provinceArr="nationalX"
                            @choiceProvince="choiceProvince">
                        </hi-map>
                    </template>
                    <template v-else>
                        <hi-map 
                            class="hiMapViewClass"
                            :mapTackData="itemNational"
                            :provinceArr="itemNationalX"
                            @choiceProvince="choiceProvince">
                        </hi-map>
                    </template>
                </div>
                <!-- 意向维度 -->
                <div class="dimensionClass">
                    <leftBackView 
                        width="60%"
                        height="60px"
                        describeText="意向维度">
                    </leftBackView>
                    <tranBarChart 
                        style="width: 100%; height: 150%"
                        width='100%'
                        height='100%'
                        :dataArr="intentionArr"
                    >
                    </tranBarChart>
                </div>
            </div>
            <!-- 右边 -->
            <div class="rightDiv">
                <!-- 部门列表 -->
                <div v-if="roleType == 1" class="departmentDivClass">
                    <rightBackView 
                        class="rightModellingClass"
                        width="80%"
                        height="60px"
                        describeText="部门列表">
                    </rightBackView>
                    <div class="allDepartmentClass">
                        <departmentView
                            width="100%"
                            height="100%"
                            :departArr="departArr"
                            @changeRole="changeRole">
                        </departmentView>
                    </div>
                </div>
                <!-- 员工列表 -->
                <div v-if="roleType == 2" class="departmentDivClass">
                    <rightBackView 
                        class="rightModellingClass"
                        width="80%"
                        height="60px"
                        describeText="员工列表">
                    </rightBackView>
                    <div class="allDepartmentClass">
                        <direDeparView
                            width="100%"
                            height="100%"
                            :departArr="staffArr"
                            @changeDire="changeDire">
                        </direDeparView>
                    </div>
                </div>
                <!-- 性别维度 -->
                <div class="genderClass">
                    <rightBackView 
                        class="rightModellingClass"
                        width="80%"
                        height="60px"
                        describeText="性别维度">
                    </rightBackView>
                    <div class="allGenderClass">
                        <template v-if="genderArr.length">
                            <genderView
                                v-for="(item, index) in genderArr"
                                :key="index"
                                width="46%"
                                height="40%"
                                :genderImg="genderImgArr[index]"
                                :totalText="item.value"
                                companyName="人"
                                :describeText="item.name">
                            </genderView>
                        </template>
                    </div>
                </div>
                <!-- 年龄纬度 -->
                <div class="ageClass">
                    <rightBackView 
                        class="rightModellingClass"
                        width="80%"
                        height="60px"
                        describeText="年龄维度">
                    </rightBackView>
                    <div class="allAgeItemClass">
                        <ageView
                            v-for="(item, index) in allAgeArr"
                            :key="index"
                            :class="index < 3 ? 'oneAgeItemClass' : 'oneAgeItemClass bottomAge'"
                            width="30%"
                            height="40%"
                            :describeText="item.name"
                            :totalText="item.value"
                            companyName="人">
                        </ageView>
                    </div>
                </div>
            </div>
        </div>
		<!-- 里面的内容—手机端 -->
		<div class="content_mobile">
			<div class="middleDiv">
			    <!-- 顶部统计数据 -->
			    <div :class="roleType == 1 ? 'topStatisClass' : 'topStatisClass chiefClass'">
			        <template v-if="roleType == 1">
			            <staticViewMobile 
			                width="110px"
			                height="107px"
			                :totalText="order_num"
			                :companyName="orderCompany"
			                describeText="订单总数">
			            </staticViewMobile>
			            <staticViewMobile 
			                width="110px"
			                height="107px"
			                :totalText="user_total"
			                companyName="人"
			                describeText="用户总数">
			            </staticViewMobile>
			            <staticViewMobile 
			                width="110px"
			                height="107px"
			                :totalText="sale_amount"
			                companyName="万"
			                describeText="销售总额">
			            </staticViewMobile>
			        </template>
			        <template v-if="roleType == 2">
			            <staticViewMobile 
			                width="110px"
			                height="107px"
			                :totalText="order_num"
			                :companyName="orderCompany"
			                describeText="订单总数">
			            </staticViewMobile>
			            <staticViewMobile 
			                width="110px"
			                height="107px"
			                :totalText="user_total"
			                companyName="人"
			                describeText="用户总数">
			            </staticViewMobile>
			        </template>
			    </div>
			    <!-- 地图 -->
			    <div class="newMapClass">
			        <template v-if="roleType == 1">
			            <hiMapMobile
			                class="hiMapViewClass"
			                :mapTackData="allNational"
			                :provinceArr="nationalX"
			                @choiceProvince="choiceProvince">
			            </hiMapMobile>
			        </template>
			        <template v-else>
			            <hiMapMobile
			                class="hiMapViewClass"
			                :mapTackData="itemNational"
			                :provinceArr="itemNationalX"
			                @choiceProvince="choiceProvince">
			            </hiMapMobile>
			        </template>
			    </div>
			    <!-- 意向维度 -->
			    <div class="mobile_button">
			        <div class="mobile_bt" v-if="roleType == 1" @click="userModelMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">用户来源渠道分布></div>
					</div>
					<div class="mobile_bt" v-if="roleType == 2" @click="userModelMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">部门客户数量></div>
					</div>
					<div class="mobile_bt" @click="userGzMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">用户跟踪情况></div>
					</div>
					<div class="mobile_bt" @click="userYxMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">意向维度></div>
					</div>
					<div class="mobile_bt" v-if="roleType == 1" @click="userBmMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">部门列表></div>
					</div>
					<div class="mobile_bt" v-if="roleType == 2" @click="userYgMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">员工列表></div>
					</div>
					<div class="mobile_bt" @click="userXbMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">性别维度></div>
					</div>
					<div class="mobile_bt" @click="userNlMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">年龄维度></div>
					</div>
			    </div>
			</div>
		</div>
        <div class="backLevelClass" v-if="roleType == 2" @click="backLevelClick">返回上一级</div>
		
        <!-- 市弹出框 -->
        <div class="cityClass" v-if="cityBool">
            <div class="topCityClass">
                <div class="allCountText">{{provinceText}}总人数 <span class="countTextClass">{{shengCount}}</span> 人</div>
                <img class="followColseClass" @click="cityBool = false" src="../assets/imgs/followColse.png" alt="">
            </div>
            <div class="cityInfoClass">
                <div :class="index % 2 !== 0 ? 'cityItemClass' : 'cityItemClass lightClass'" 
                    v-for="(item, index) in cityItemArr" :key="index" @click="seeRound(item)">
                    <div class="cityNameClass">{{item.belonging_city_name}}</div>
                    <div class="cityNameClass">{{item.value}}人</div>
                    <div class="seeCityClass" >查看分布情况</div>
                </div>
            </div>
        </div>
		<!-- 市弹出框，手机端 -->
		<div class="cityClass_mobile" v-if="cityBool">
		    <div class="topCityClass">
		        <div class="allCountText">{{provinceText}}总人数 <span class="countTextClass">{{shengCount}}</span> 人</div>
		        <img class="followColseClass" @click="cityBool = false" src="../assets/imgs/followColse.png" alt="">
		    </div>
		    <div class="cityInfoClass">
		        <div :class="index % 2 !== 0 ? 'cityItemClass' : 'cityItemClass lightClass'" 
		            v-for="(item, index) in cityItemArr" :key="index" @click="seeRound(item)">
		            <div class="cityNameClass">{{item.belonging_city_name}}</div>
		            <div class="cityNameClass">{{item.value}}人</div>
		            <div class="seeCityClass" >查看分布情况</div>
		        </div>
		    </div>
		</div>
		<div></div>
        <!-- 市图表 -->
        <div class="cityClass" v-show="cityChartBool">
            <div class="topCityClass">
                <img class="followBackClass" src="../assets/imgs/followBack.png" @click="cityChartBool = false" alt="">
                <div class="followText">来源渠道分布</div>
                <img class="followColseClass" src="../assets/imgs/followColse.png" @click="cityChartBool = false" alt="">
            </div>
            <div class="cityInfoClass">
                <roundChart1 
                    style="width: 100%; height: 80%" 
                    :dataArr="cityData"
                    :totalText="citySum">
                </roundChart1>
            </div>
        </div>
		<!-- 市图标 手机端 -->
		<div class="cityClass_mobile" v-show="cityChartBool">
		    <div class="topCityClass">
		        <img class="followBackClass" src="../assets/imgs/followBack.png" @click="cityChartBool = false" alt="">
		        <div class="followText">来源渠道分布</div>
		        <img class="followColseClass" src="../assets/imgs/followColse.png" @click="cityChartBool = false" alt="">
		    </div>
		    <div class="cityInfoClass">
		        <roundChart1 
		            style="width: 100%; height: 80%" 
		            :dataArr="cityData"
		            :totalText="citySum">
		        </roundChart1>
		    </div>
		</div>
		<!-- 用户渠道分布弹窗 移动端 -->
		<div v-show="userModelMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile">
			    <div class="TjMobileClass">
			        <div class="followTextMobile">用户来源渠道分布</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userModelMobile = false" alt="">
			    </div>
			        <roundChartMobile
			            style="width: 300%; height: 300%"
			            :dataArr="userData"
			            :totalText="userSum">
			        </roundChartMobile>
			</div>
		</div>
		
		<!-- 用户跟踪情况弹窗 移动端 -->
		<div v-show="userGzMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">用户跟踪情况</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userGzMobile = false" alt="">
			    </div>
			        <template v-if="!solidXArr">
			            <div class="noDataClass">
			                暂无数据
			            </div>
			        </template>
			        <template v-else>
			            <solidBarChart 
			                width='300px'
			                height='260px'
			                refName="newSolidBar"
			                :chartXArr="solidXArr"
			                :chartYArr="solidYArr">
			            </solidBarChart>
			        </template>
			</div>
		</div>
		
		<!-- 意向维度弹窗 移动端 -->
		<div v-show="userYxMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">意向维度</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userYxMobile = false" alt="">
			    </div>
			        <tranBarChartMobile
			            width='300px'
			            height='250px'
			            :dataArr="intentionArr"
			        >
			        </tranBarChartMobile>
			</div>
		</div>
		
		<!-- 部门列表弹窗 移动端 -->
		<div v-show="userBmMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">部门列表</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userBmMobile = false" alt="">
			    </div>
			        <departmentView
			            width="90%"
			            height="100%"
			            :departArr="departArr"
						@changeRoleMobile="changeRoleMobile"> <!-- 移动端逻辑 -->
			        </departmentView>
			</div>
		</div>
		
		<!-- 性别维度弹窗 移动端 -->
		<div v-show="userXbMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">性别维度</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userXbMobile = false" alt="">
			    </div>
			        <div class="allGenderClass">
			            <template v-if="genderArr.length">
			                <genderView
			                    v-for="(item, index) in genderArr"
			                    :key="index"
			                    width="80%"
			                    height="20%"
			                    :genderImg="genderImgArr[index]"
			                    :totalText="item.value"
			                    companyName="人"
			                    :describeText="item.name">
			                </genderView>
			            </template>
			        </div>
			</div>
		</div>
		
		<!-- 年龄维度弹窗 移动端 -->
		<div v-show="userNlMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">年龄维度</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userNlMobile = false" alt="">
			    </div>
			        <div class="allAgeItemClass">
			            <ageView
			                v-for="(item, index) in allAgeArr"
			                :key="index"
			                :class="index < 3 ? 'oneAgeItemClass' : 'oneAgeItemClass bottomAge'"
			                width="40%"
			                height="27%"
			                :describeText="item.name"
			                :totalText="item.value"
			                companyName="人">
			            </ageView>
			        </div>
			</div>
		</div>
		<div v-show="userYgMobile">
			<div class="tj_mobile_mask"></div>
			<div class="tj_mobile" >
			    <div class="TjMobileClass">
			        <div class="followTextMobile">员工列表</div>
			        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userYgMobile = false" alt="">
			    </div>
			        <div class="allDepartmentClass">
			            <direDeparView
			                width="95%"
			                height="100%"
			                :departArr="staffArr"
			                @changeDire="changeDire">
			            </direDeparView>
			        </div>
			</div>
		</div>
    </div>
</template>

<script>
import leftBackView from '../../components/modellingLeft.vue'
import rightBackView from '../../components/modellingRight.vue'
import staticView from '../../components/statisData.vue'
import genderView from "../../components/genderView.vue";
import ageView from "../../components/ageView.vue"
import departmentView from "../../components/departmentView.vue"
import direDeparView from "../../components/direDeparView.vue"
import roundChart from '../../components/roundChart.vue'
import roundChart1 from '../../components/roundChart1.vue'
import solidBarChart from '../../components/solidBarChart.vue'
import tranBarChart from '../../components/tranBarChart.vue'
import hiMap from '../../components/newHiMap.vue'
import auxiliaryRound from '../../components/auxiliaryRound.vue'
//手机端组件
import staticViewMobile from '../../components/statisDataMobile.vue'
import hiMapMobile from '../../components/newHiMapMobile.vue'
import roundChartMobile from '../../components/roundChartMobile.vue'
import tranBarChartMobile from '../../components/tranBarChartMobile.vue'

import request from '@/utils/request'

export default {
    components:{
        leftBackView,
        rightBackView,
        staticView,
        genderView,
        ageView, 
        departmentView,
        direDeparView,
        hiMap,
        roundChart,
        solidBarChart,
        tranBarChart,
        roundChart1,
        auxiliaryRound,
		//手机端组件引用
		staticViewMobile,
		hiMapMobile,
		roundChartMobile,
		tranBarChartMobile
    },
    data(){
        return{
            order_num: '',
            user_total: '',
            sale_amount: '',
            roleId: 0,
            regionId: 0,
            orderCompany: '',
            
            genderArr: [],
            genderImgArr: [
                require('@/assets/imgs/manGender.png'),
                require('@/assets/imgs/womanGender.png'),
                require('@/assets/imgs/unknownGender.png')
            ],
            departArr: [],
            staffArr: [],

            allAgeArr: [],
            roleType: '1',
            jiWeiBool: true,
            userData: [],
            userSum: 0,
            intentionArr: [],
            cityBool: false,
            cityChartBool: false,

            cityData: [],
            citySum: 0,
            allNational: [],
            nationalX: [],

            areaArr: [],
            cityItemArr: [],
            shengCount: 0,

            solidXArr: [],
            solidYArr: [],

            itemNational: [],
            itemNationalX: [],
		
            dateStr: '',
			dateStr_mobile:'',//手机端显示时间
            provinceText: '',
			userModelMobile:false,//手机端用户来源分布弹窗控制
			userGzMobile:false,
			userYxMobile:false,//手机端意向维度弹窗控制
			userBmMobile:false,//手机端部门列表弹窗控制
			userXbMobile:false,//手机端性别维度弹窗控制
			userNlMobile:false,//手机端年龄维度弹窗控制
			userYgMobile:false,//手机端员工列表弹窗控制
        }
    },
    created(){
        const whichType = localStorage.getItem('whichType')
        // if(whichType == 'no'){
        //     this.roleType = 2
        //     const regionId = this.$route.query.regionId
        //     this.changeRole(regionId)
        // }else{
        //     this.roleType = 1

        //     this.getSaleDataFunc()
        //     // 部门列表
        //     this.getDepartFunc()
        // }

        this.getSaleDataFunc()
        // 部门列表
        this.getDepartFunc()

        // 右上角时间
        setInterval(() => {
            this.getNowTime();
        }, 1000);
    },
	watch: {
	  userModelMobile(val) {
	    document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userGzMobile(val){
		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userYxMobile(val){
	  		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userBmMobile(val){
	  		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userXbMobile(val){
	  		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userNlMobile(val){
	  		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  userYgMobile(val){
	  		  document.body.style.overflow = val ? 'hidden' : '';
	  },
	  // 其他弹窗的watch同理
	},
    methods:{
        // 获取当前时间
        getNowTime(){
            // 创建一个新的Date对象，表示当前时间
            var currentDate = new Date();

            // 获取年、月、日、小时、分钟和秒
            var year = currentDate.getFullYear();
            var month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，所以要加1，并补零
            var day = currentDate.getDate().toString().padStart(2, '0'); // 补零
            var hours = currentDate.getHours().toString().padStart(2, '0'); // 补零
            var minutes = currentDate.getMinutes().toString().padStart(2, '0'); // 补零
            var seconds = currentDate.getSeconds().toString().padStart(2, '0'); // 补零

            // 拼接日期和时间字符串
            this.dateStr = year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds;
			this.dateStr_mobile = year + ' ' + month + '/' + day
        },
        getSaleDataFunc(){
            this.order_num = ''
            this.user_total = ''
            this.sale_amount = ''
            this.genderArr = []
            this.areaArr = []

            request({
                url: 'statistics.MemberAnalysis/count',
                method: 'GET',
            }).then(res => {
                if(res.code == 200){
                    let orderStr = res.data.order_num.replace(/,/g, '');
                    if(orderStr.length > 4){
                        let orderNumber = Number(orderStr)
                        // 四舍五入并转换为带有“万”单位的字符串
                        const roundedNum = Math.round(orderNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
                        this.order_num = roundedNum.toFixed(2);
                        this.orderCompany = '万'

                    }else{
                        this.order_num = res.data.order_num
                        this.orderCompany = '个'
                    }

                    this.user_total = res.data.user_total + ''
                    let saleStr = res.data.sale_amount.replace(/,/g, '');
                    let saleNumber = Number(saleStr)
                    // 四舍五入并转换为带有“万”单位的字符串
                    const roundedNum = Math.round(saleNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
                    this.sale_amount = roundedNum.toFixed(2);
                    this.genderArr = res.data.gender
                    this.allAgeArr = res.data.age
                    this.userData = res.data.referer.list
                    this.userSum = res.data.referer.sum

                    this.areaArr = res.data.area

                    let value1 = 0
                    let value2 = 0
                    let intention = []
                    intention = res.data.intention
                    if(intention.length > 2){
                        value1 = res.data.intention[0].value
                        value2 = res.data.intention[1].value
                        this.intentionArr = [value1, value2]
                    }else{
                        this.intentionArr = [0, 0]
                    }

                    let provinceArr = []
                    this.allNational = res.data.area
                    this.allNational.forEach(item => {
                        item.value = item.value
                        item.name = item.name

                        provinceArr.push(item.name)
                    });
                    this.nationalX = provinceArr

                    this.solidXArr = res.data.record.xAxis
                    this.solidYArr = res.data.record.series
                }
            })
        },
        getDepartFunc(){
            request({
                url: 'statistics.MemberAnalysis/deptList',
                method: 'GET',
            }).then(res => {
                if(res.code == 200){
                    this.departArr = res.data.list
                }
            })
        },
        changeRole(id){
            this.roleType = 2
            this.regionId = id

            localStorage.setItem('whichType', 'no')

            this.order_num = ''
            this.user_total = ''
            this.sale_amount = ''
            this.genderArr = []
            this.areaArr = []

            this.nationalX = []
            this.allNational = []
            request({
                url: `statistics.MemberAnalysis/count?dept_id=${id}`,
                method: 'GET',
            }).then(res => {
                if(res.code == 200){
                    let orderStr = res.data.order_num.replace(/,/g, '');
                    if(orderStr.length > 4){
                        let orderNumber = Number(orderStr)
                        // 四舍五入并转换为带有“万”单位的字符串
                        const roundedNum = Math.round(orderNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
                        this.order_num = roundedNum.toFixed(2);
                        this.orderCompany = '万'

                    }else{
                        this.order_num = res.data.order_num
                        this.orderCompany = '个'
                    }

                    // this.order_num = res.data.order_num
                    this.user_total = res.data.user_total + ''
                    let saleStr = res.data.sale_amount.replace(/,/g, '');
                    let saleNumber = Number(saleStr)
                    console.log('saleNumber.  ', saleNumber)
                    // 四舍五入并转换为带有“万”单位的字符串
                    const roundedNum = Math.round(saleNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
                    this.sale_amount = roundedNum.toFixed(2);
                    this.genderArr = res.data.gender
                    this.allAgeArr = res.data.age
                    this.userData = res.data.referer.list
                    this.userSum = res.data.referer.sum

                    this.areaArr = res.data.area

                    let value1 = 0
                    let value2 = 0
                    let intention = []
                    intention = res.data.intention
                    if(intention.length > 2){
                        value1 = res.data.intention[0].value
                        value2 = res.data.intention[1].value
                        this.intentionArr = [value1, value2]
                    }else{
                        this.intentionArr = [0, 0]
                    }

                    let provinceArr = []
                    
                    this.itemNational = res.data.area
                    if(this.itemNational.length > 0){
                        this.itemNational.forEach(item => {
                            item.value = item.value
                            item.name = item.name
    
                            provinceArr.push(item.name)
                        });
                    }else{
                        provinceArr = []
                    }
                    this.itemNationalX = provinceArr

                    this.solidXArr = res.data.record.xAxis
                    this.solidYArr = res.data.record.series
                }
            })
            // 规划师列表
            request({
                url: `statistics.MemberAnalysis/plannerList?dept_id=${id}`,
                method: 'GET',
            }).then(res => {
                if(res.code == 200){
                    // this.staffArr = res.data
                    this.staffArr = res.data.list
                }
            })
        },
		//移动端
		changeRoleMobile(id){
			this.userBmMobile = false;
			this.roleType = 2
			this.regionId = id
			
			localStorage.setItem('whichType', 'no')
			
			this.order_num = ''
			this.user_total = ''
			this.sale_amount = ''
			this.genderArr = []
			this.areaArr = []
			
			this.nationalX = []
			this.allNational = []
			request({
			    url: `statistics.MemberAnalysis/count?dept_id=${id}`,
			    method: 'GET',
			}).then(res => {
			    if(res.code == 200){
			        let orderStr = res.data.order_num.replace(/,/g, '');
			        if(orderStr.length > 4){
			            let orderNumber = Number(orderStr)
			            // 四舍五入并转换为带有“万”单位的字符串
			            const roundedNum = Math.round(orderNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
			            this.order_num = roundedNum.toFixed(2);
			            this.orderCompany = '万'
			
			        }else{
			            this.order_num = res.data.order_num
			            this.orderCompany = '个'
			        }
			
			        // this.order_num = res.data.order_num
			        this.user_total = res.data.user_total + ''
			        let saleStr = res.data.sale_amount.replace(/,/g, '');
			        let saleNumber = Number(saleStr)
			        console.log('saleNumber.  ', saleNumber)
			        // 四舍五入并转换为带有“万”单位的字符串
			        const roundedNum = Math.round(saleNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
			        this.sale_amount = roundedNum.toFixed(2);
			        this.genderArr = res.data.gender
			        this.allAgeArr = res.data.age
			        this.userData = res.data.referer.list
			        this.userSum = res.data.referer.sum
			
			        this.areaArr = res.data.area
			
			        let value1 = 0
			        let value2 = 0
			        let intention = []
			        intention = res.data.intention
			        if(intention.length > 2){
			            value1 = res.data.intention[0].value
			            value2 = res.data.intention[1].value
			            this.intentionArr = [value1, value2]
			        }else{
			            this.intentionArr = [0, 0]
			        }
			
			        let provinceArr = []
			        
			        this.itemNational = res.data.area
			        if(this.itemNational.length > 0){
			            this.itemNational.forEach(item => {
			                item.value = item.value
			                item.name = item.name
			    
			                provinceArr.push(item.name)
			            });
			        }else{
			            provinceArr = []
			        }
			        this.itemNationalX = provinceArr
			
			        this.solidXArr = res.data.record.xAxis
			        this.solidYArr = res.data.record.series
			    }
			})
			// 规划师列表
			request({
			    url: `statistics.MemberAnalysis/plannerList?dept_id=${id}`,
			    method: 'GET',
			}).then(res => {
			    if(res.code == 200){
			        // this.staffArr = res.data
			        this.staffArr = res.data.list
			    }
			})
		},
        changeDire(id){
            console.log(id)
            this.$router.push(`userInfo?userId=${id}&regionId=${this.regionId}`);

            localStorage.setItem('whichType', 'no')
        },
        backLevelClick(){
            this.roleType = 1
            this.getSaleDataFunc()

            localStorage.setItem('whichType', 'yes')
        },
        // 移入
        mouseEnter(){
            this.jiWeiBool = false
        },
        // 移除
        mouseLeave(){
            this.jiWeiBool = true
        },
        // 去几维空间
        gojiweiClick(){
            this.$router.push(`/?type=1`);
        },
        // 点击省份
        choiceProvince(name){
            if(this.areaArr.length > 0){
                this.areaArr.forEach(item => {
                    if(item.name == name){
                        this.cityItemArr = item.children
                        this.shengCount = item.value
                        this.provinceText = item.fullName
                    }
                });
                this.cityBool = true
            }
        },
        // 查看某个城市饼状图
        seeRound(info){
            this.cityChartBool = true

            this.cityData = info.channel_values
            this.citySum = info.value

            console.log('this.cityData', this.cityData, this.citySum)
        }
    }
}
</script>

<style lang="scss" scoped>
.newHiYouCaiDiv{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    background-image: url('../assets/imgs/newHiBigBack.png');
    background-size: 100% 100%;
    background-color: #131D27;
}
.hiYouCaiTitleClass{
    margin: 2.8% auto 0;
    display: flex;
    justify-content: space-between;
    width: 84%;
    // background-color: white;
}
.leftModellingClass{
    display: flex;
    width: 26%;
    height: 50px;
    background-image: url('../assets/imgs/leftModelling.png');
    background-size: 100% 100%;
    // background-color: white;
}
.topRightModellingClass{
    display: flex;
    width: 26%;
    height: 50px;
    background-image: url('../assets/imgs/rightModelling.png');
    background-size: 100% 100%;
    // background-color: white;
}
.topRightModellingClass_mobile{
	display: none;
}
.jiweiClass{
    margin: auto;
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    cursor: pointer;
}
.jiweiClass_mobile{
	display: none;
}
.goJiWeiClass{
    margin: auto;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 24px;
    text-shadow: 0px 2px 4px #A0E9FF;
    cursor: pointer;
}
.contentDiv{
    display: flex;
    margin: -0.8% auto 0;
    width: calc(100% - 40px);
    height: calc(100% - 160px);
    // background-color: aquamarine;
}
.content_mobile{
	display: none;
}
.leftDiv{
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 100%;
    // background-color: #F3FCFF;
}
.leftTopDiv{
    width: 100%;
    height: 50%;
    // background-color: #F3FCFF;
}
.leftBottomDiv{
    width: 100%;
    height: 50%;
    // background-color: #48b2d5;
    position: relative;
}
.noDataClass{
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #11EFE1;
    position: absolute;
    z-index: 999999999999999;
}
.modellingClass{
    margin: 20px auto 0 5%;
}
.middleDiv{
    width: 40%;
    height: 100%;
    // background-color: #84d9f5;
}
.topStatisClass{
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: space-between;
    justify-content: space-around;
    // background-color: #58bbdc;
}
.chiefClass{
    margin: 0 auto;
    width: 80%;
}
.newMapClass{
    width: 100%;
    height: 60%;
    // background-color: #F3FCFF;
}
.dimensionClass{
    width: 100%;
    height: 20%;
    // background-color: #F3FCFF;
}
.rightDiv{
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 100%;
}
.departmentDivClass{
    width: 99%;
    height: 37%;
    z-index: 100;
}
.allDepartmentClass{
    width: 100%;
    height: calc(100% - 60px);
    // background-color: #F3FCFF;
}
.genderClass{
    margin-top: 2px;
    width: 100%;
    height: 26%;
    // background-color: #F3FCFF;
}
.allGenderClass{
    height: calc(100% - 60px);
    // margin-left: 3%;
    display: flex;
    flex-wrap: wrap;
    // background-color: white;
}
.ageClass{
    width: 100%;
    height: calc(37% - 20px);
    // background-color: antiquewhite;
}
.rightModellingClass{
    margin: 20px 20px 0 calc(20% - 20px);
}
.allAgeItemClass{
    margin-left: 18%;
    width: 82%;
    height: calc(100% - 60px);
    display: flex;
    flex-wrap: wrap;
}
.oneAgeItemClass{
    margin-top: 2%;
}
.bottomAge{
    margin-top: 5%;
}
.backLevelClass{
    margin: auto auto 10px;
    width: 200px;
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    cursor: pointer;
    // background-color: #F3FCFF;
    z-index: 100;
}
.backLevelClass:hover{
    color: #12F6E9;
}
.hiMapViewClass{
    width: 100%;
    height: 100%;
}
.topCityClass{
    display: flex;
    justify-content: space-between;
    margin: 10px 30px;

}
.cityClass{
    position: fixed;
    top: 25%;
    left: 30%;
    width: 40%;
    height: 50%;
    border: 10px solid #54A3FF;
    // border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
    border-radius: 25px;
    background-color: #01030F;
    z-index: 110;
}
.cityInfoClass{
    margin: 2%;
    height: calc(94% - 60px);
    // background-color: #12F6E9;
}
.allCountText{
    font-weight: 600;
    font-size: 28px;
    color: #FFFFFF;
    text-align: left;
}
.countTextClass{
    font-weight: 600;
    font-size: 28px;
    color: #11EFE1;
}
.followColseClass{
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    margin: auto 0;
    cursor: pointer;
}
.cityItemClass{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 30px 0;
    height: 40px;
    background-color: #01030F;
    cursor: pointer;
}
.lightClass{
    background: linear-gradient( 270deg, rgba(94,234,255,0) 0%, rgba(71,221,255,0.3) 47%, rgba(48,208,255,0) 100%);
}
.cityNameClass{
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    min-width: 100px;
}
.seeCityClass{
    font-weight: 500;
    font-size: 14px;
    color: #11EFE1;
    cursor: pointer;
}
.followBackClass{
    margin: auto 0;
    width: 41px;
    height: 30px;
    background-size: 100% 100%;
    cursor: pointer;
}
.followColseClass{
    margin: auto 0;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    cursor: pointer;
}
.followText{
    margin: auto;
    font-weight: 600;
    font-size: 38px;
    color: #FFFFFF;
}
//控制手机端弹窗，在pc不显示
.cityClass_mobile{
	display: none;
}
@media (max-width: 768px) {
  // 根元素
  .allAgeItemClass {
  	margin-left: 8%;
  	width: 92%;
  	height: calc(100% - 80px);
  	display: flex;
  	flex-wrap: wrap;
  }
  .newHiYouCaiDiv{
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100vh;
      background-image: url('../assets/imgs/mobile_back.png');
      background-size: 100% 100%;
      background-color: #131D27;
  }
  .hiYouCaiTitleClass{
	  margin: 3.8% auto 0;
	  display: flex;
	  justify-content: space-between;
	  width: 100%;
  }
  .leftModellingClass{
      display: flex;
      width: 139px;
      height: 71px;
      background-image: url('../assets/imgs/mobile_back_left.png');
      background-size: 100% 100%;
      // background-color: white;
  }
  .topRightModellingClass{
	  display: none;
  }
  .topRightModellingClass_mobile{
      display: flex;
      width: 139px;
      height: 71px;
      background-image: url('../assets/imgs/mobile_back_right.png');
      background-size: 100% 100%;
      // background-color: white;
	  .jiweiClass{
		  display: block;
		  margin: auto;
		  color: #FFFFFF;
		  font-weight: 600;
		  font-size: 8px;
		  transform: rotate(-5deg);
	  }
	  .goJiWeiClass{
		  display: block;
		  margin: auto;
		  color: #FFFFFF;
		  font-weight: 600;
		  font-size: 8px;
		  transform: rotate(-5deg);
	  }
  }
  .leftModellingClass{
	  .jiweiClass{
		  display: none;
	  }
  }
  .jiweiClass{
    font-weight: 600;
    font-size: 12px;
  }
  .jiweiClass_mobile{
	  display: block;
	  margin: auto;
	  color: #FFFFFF;
	  font-weight: 600;
	  font-size: 10px;
	  transform: rotate(5deg);
  }
  //手机端内容部分
  
  .contentDiv{
	  display: none;
  }
  .content_mobile{
	  display: block;
	  width: calc(100% - 20px);
	  height: calc(100% - 40px);
	  margin: auto;
	  .middleDiv{
		  width: 90%;
		  height: 100%;
		  margin: auto;
		  .newMapClass{
		      width: 100%;
		      height: 300px; // 或使用百分比如60%
		  }
	  }
  }
  .mobile_button{
	  width: 340px;
	  margin: 15px auto;
	  height: 90px;
	  display: flex;
	  justify-content: space-between;
	  flex-wrap: wrap;
	  .mobile_bt{
		  display: flex;
		  width: 32%;
		  height: 30px;
		  background-image: url(../assets/imgs/leftModelling.png);
		  background-size: 125% 100%;
		  background-position: center;
		  .mobile_icon{
			  width: 14px;
			  height: 14px;
		  }
		  .mobile_txt{
			  color: #fff;
			  font-size: 10px;
			  line-height: 20px;
			  text-indent: 2px;
		  }
	  }
  }
  .tj_mobile_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); // 半透明黑色遮罩
    z-index: 100; // 确保在弹窗下方
  }
  .tj_mobile{
	  display: block;
	  position: fixed;
	  top: 25%;
	  left: 6%;
	  width: 79%;
	  height: 50%;
	  border: 10px solid #54A3FF;
	  // border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
	  border-radius: 25px;
	  background-color: #01030F;
	  z-index: 110;
	  .TjMobileClass{
		  width: 90%;
		  display: flex;
		  justify-content: space-between;
		  font-weight: 600;
		  font-size: 16px;
		  color: #FFFFFF;
		  margin: 15px auto;
		  .followColseClassMobile{
			  width: 25px;
			  height: 25px;
			  z-index: 999;
		  }
	  }
  }
  .followColseClass{
	  width: 25px;
	  height: 25px;
  }
  .allGenderClass{
	  display: block;
  }
  .bottomAge{
	  margin-top: 2%;
  }
  .cityClass{
	  display: none;
  }
  .cityClass_mobile{
  	display: block;
	position: fixed;
	top: 25%;
	left: 6%;
	width: 79%;
	height: 50%;
	border: 10px solid #54A3FF;
	// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
	border-radius: 25px;
	background-color: #01030F;
	z-index: 110;
	.allCountText{
	  font-size: 20px;
	  .countTextClass{
	      font-size: 20px;
	  }
	}
	.followText{
		font-size: 20px;
	}
	.cityItemClass{
		margin: 10px 10px 0;
	}
	.cityNameClass{
		min-width: 80px;
	}
	.seeCityClass{
		min-width: 80px;
		font-size: 12px;
	}
  }
  .backLevelClass {
  	margin: auto auto 2%;
  	width: 200px;
  	font-weight: 600;
  	font-size: 18px;
  	color: #FFFFFF;
  	cursor: pointer;
  	z-index: 100;
  	// background-color: #F3FCFF;
  }
}
</style>